import { Grid } from '@mui/material';
import AnalyzerStatusWidgetTable from './AnalyzerStatusWidgetTable';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import { NetworkCheck } from '@mui/icons-material';

import { useAnalyzers } from 'features/analyzers/api/getAnalyzers';

const AnalyzerStatusWidget = () => {
  const { data: instruments } = useAnalyzers({
    config: { refetchInterval: 60000 },
  });

  return (
    <Grid item xs={12} container component={Paper} justifyContent={'center'}>
      <Grid item container xs={12} alignItems='center' justifyContent='center'>
        <NetworkCheck />
        <Grid item style={{ marginLeft: '.3rem' }}>
          <Typography
            component='h4'
            variant='h6'
            style={{ textAlign: 'center' }}
          >
            Analyzer Connection Status
          </Typography>
        </Grid>
      </Grid>
      {instruments?.length !== 0 ? (
        <Grid container item style={{ maxHeight: '16rem', overflow: 'auto' }}>
          <AnalyzerStatusWidgetTable instruments={instruments} />
        </Grid>
      ) : (
        <Grid
          item
          xs={12}
          style={{
            paddingBottom: '1rem',
            marginLeft: '1rem',
            marginTop: '.2rem',
          }}
        >
          <Typography align='left' variant='body2'>
            No analyzers present.
          </Typography>
        </Grid>
      )}
    </Grid>
  );
};
export default AnalyzerStatusWidget;
